<template>
  <b-container class="copyright text-muted pt-3 pb-5">
    <p>
      <router-link :to="{ name: 'Disclaimer' }">Disclaimer</router-link> |
      <a href="/privacy.aspx" target="_blank">Privacy Policy</a> |
      <a href="/terms.aspx" target="_blank">Terms & Conditions</a>
    </p>
    <p>Copyright &copy; {{ year }} Shark Investing. All Rights Reserved.</p>
  </b-container>
</template>

<script>
export default {
  name: "Copyright",
  data: () => ({
    year: "",
  }),
  mounted() {
    this.year = new Date().getFullYear().toString();
  },
};
</script>

<style lang="scss" scoped>
.copyright p {
  font-size: 0.75rem;
}
</style>
